module.exports = __webpack_public_path__ + "img/pdf.df7994fd.svg";